export const isUserAuthorized = (role) => {
    return role === 'superadmin';
}